import { GameModes, GoalType, Mod } from './../../../interfaces/Bounty';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  TransitionController,
  Transition,
  TransitionDirection
} from 'ng2-semantic-ui';

export interface FilterCategory {
  header: string;
  filters: string[];
}

const typeFilters: GoalType[] = ['beatmap', 'pp', 'tournament'];
const gameModeFilters: GameModes[] = ['osu', 'mania', 'ctb', 'taiko'];
const modFilters: Mod[] = ['nomod', 'hd', 'hr', 'dt', 'ht', 'ez', 'fl'];
const miscFilters = ['trusted-only', 'has-claims'];
export const allFilters = [].concat(
  typeFilters,
  gameModeFilters,
  modFilters,
  miscFilters,
);

@Component({
  selector: 'app-bounties-filters',
  templateUrl: './bounties-filters.component.html',
  styleUrls: ['./bounties-filters.component.scss'],
})
export class BountiesFiltersComponent implements OnInit {
  @Input() selectedFilters: string[];
  @Input() searchTerm: string;

  @Output() filterRemoved = new EventEmitter<string>();
  @Output() filterAdded = new EventEmitter<string>();
  @Output() searchCleared = new EventEmitter<undefined>();
  @Output() filtersCleared = new EventEmitter<undefined>();

  public transitionController = new TransitionController(false);
  public visible = false;
  public typeFilters: GoalType[] = typeFilters;
  public gameModeFilters: GameModes[] = gameModeFilters;
  public modFilters: Mod[] = modFilters;
  public miscFilters: string[] = miscFilters;
  public allValidFilters = allFilters;
  public filterCategories: FilterCategory[] = [
    { header: 'Game Modes', filters: this.gameModeFilters },
    { header: 'Bounty Types', filters: this.typeFilters },
    { header: 'Mods', filters: this.modFilters },
    { header: 'Misc', filters: this.miscFilters },
  ];

  constructor() {}

  ngOnInit() {}

  public toggle() {
    this.transitionController.animate(
      new Transition('slide down', 150, TransitionDirection.Either),
    );
  }

  public clearSearch() {
    this.searchCleared.next();
  }

  public resetAllFilters() {
    this.filtersCleared.next();
  }

  public removeFilter(filter: string) {
    this.filterRemoved.next(filter);
  }

  private addFilter(filter: string) {
    this.filterAdded.next(filter);
  }

  public toggleFilter(filter: string) {
    if (this.selectedFilters.includes(filter)) {
      this.removeFilter(filter);
    } else {
      this.addFilter(filter);
    }
  }
}
